<template>
  <div>
    <el-row class="title-bar vertical-center-box" type="flex" justify="end">
      <el-button class="mr-r4" :disabled="checkedRows.length === 0" @click="onClickReleaseButton">해제</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool" size="mini"></w-header-search-button>
    </el-row>
    <el-table-wrapper :data="checkedObjList" :columns="tableColumns" :column-default="columnDefault" ref="selectedObjTable":pagination="true" :show-custom-header="true"
    :show-search-tool="showSearchTool" @selection-change="changeCheckedRow" :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight">
    </el-table-wrapper>
  </div>
</template>

<script>
import { isEmpty, isNil } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WSelectedObjTable',
  props: {
    fitHeight: {
      type: Boolean,
      default: false,
    },
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    customTableColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columnDefault,
      showSearchTool: false,
      checkedRows: [],
      columns: [
        {
          type: 'selection',
          width: 55,
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 110,
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'objName',
          label: '대상명',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          width: 120,
          searchable: true,
          formatter: defaultFormatter,
        },
      ],
    };
  },
  computed: {
    tableColumns() {
      if (isEmpty(this.customTableColumns)) {
        return this.columns;
      }
      return this.customTableColumns;
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    onClickReleaseButton() {
      this.checkedRows.forEach((row) => {
        // AP 컨트롤러의 권한을 제거할 때 하위 무선 AP 들의 권한도 함께 제거합니다.
        if (row.objDefineId === 'WIRELESS_DEVICE' && row.objtypeId === 'AP_CONTROLLER') {
          this.checkedObjList.forEach((o) => {
            if (!isNil(o.parentObjId)) {
              if (o.parentObjId === row.objId) {
                this.checkedObjList.splice(this.checkedObjList.indexOf(o), 1);
              }
            }
          });
        }
        this.checkedObjList.splice(this.checkedObjList.indexOf(row), 1);
      });
      this.$emit('reload-obj-list');
    },
  },
};
</script>

<style lang="scss">
.h100 {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/table/SelectedObjTable.vue